import { render, staticRenderFns } from "./SmmPage.vue?vue&type=template&id=18b72d50&scoped=true&"
import script from "./SmmPage.vue?vue&type=script&lang=js&"
export * from "./SmmPage.vue?vue&type=script&lang=js&"
import style0 from "./SmmPage.vue?vue&type=style&index=0&id=18b72d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b72d50",
  null
  
)

export default component.exports